import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import SchoolForm from 'Services/ControlDataManagement/Features/School/Components/SchoolForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/system'
import { t } from 'ttag'

function SchoolCreatePage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/school-management/schools`
  const previousLocation = usePreviousLocation(baseUrl)
  const breadcrumbs = [
    {
      title: t`Home`,
      link: '/control-data-management/'
    },
    {
      title: t`Schools`,
      link: baseUrl
    },
    {
      title: t`Create new school or unit`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new school or unit`}</PageTitle>
        </Grid>
      </Grid>
      <SchoolForm successBaseUrl={previousLocation} />
    </Box>
  )
}

export default SchoolCreatePage
